import React from 'react';
import { Grid, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useStyles } from './style';
import { useHistory } from 'react-router-dom';

interface Props {
  selectedIndex: number;
}

export function PersonProfileNavbar(props: Props) {
  const { t } = useTranslation();
  const style = useStyles();
  const history = useHistory();

  function getButtonStyle(btnIndex: number) {
    const { selectedIndex } = props;
    if (selectedIndex === btnIndex) return 'outlined';
  }

  return (
    <Grid
      item
      container
      xl
      direction='row'
      justify='center'
      spacing={2}
      className={style.container}
    >
      <Grid item>
        <Button
          variant={getButtonStyle(1)}
          color='primary'
          onClick={() => history.push('/my-profile')}
        >
          {t('personal')}
        </Button>
      </Grid>
      <Grid item>
        <Button
          variant={getButtonStyle(2)}
          color='primary'
          onClick={() => history.push('/roles-and-certs')}
        >
          {t('roles_and_certifications')}
        </Button>
      </Grid>
      <Grid item>
        <Button
          variant={getButtonStyle(3)}
          color='primary'
          onClick={() => history.push('/registrations')}
        >
          {t('registrations')}
        </Button>
      </Grid>
    </Grid>
  );
}
